module.exports = "<div class=\"vis-visualisation\">\n  <slot></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-visualisation/src/components/visualisation.html
// module id = 311
// module chunks = 0